import { parseISO } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export const shiftDate = (isoString: string) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localDate = parseISO(isoString.replace(/Z$/, ''));
  const utcDate = fromZonedTime(localDate, timeZone);

  return utcDate.toISOString();
};
